/**
 * Runs `task` over `items` with at most `limit` in flight, keeping the input
 * order in the result. A worker pool, not chunks: one slow request does not
 * hold back the others. A rejected task rejects the whole run, so a caller that
 * needs every outcome catches inside `task`.
 */
export async function mapLimited<T, R>(items: readonly T[], limit: number, task: (item: T) => Promise<R>): Promise<R[]> {
  const results = new Array<R>(items.length);
  let next = 0;
  const worker = async () => {
    while (next < items.length) {
      const index = next;
      next += 1;
      results[index] = await task(items[index]);
    }
  };
  await Promise.all(Array.from({ length: Math.max(1, Math.min(limit, items.length)) }, () => worker()));
  return results;
}
